export default "__VITE_ASSET__CDosooy1__"